<template>
  <el-button :loading="isLoading" @click="replyProjectConfirm">{{text}}</el-button>
</template>
<script>
import { saveReply } from '@/services/proj/bid-reply-service';
export default {
  name: 'ProjBidBtnDeleteList',
  props: {
    project: {
      required: true,
      tyle: Object
    },
    text: {
      default: '参与项目'
    }
  },
  data() {
    return {
      user: this.$store.state.user.userInfo,
      isLoading: false
    };
  },
  methods: {
    replyProjectConfirm: function() {
      this.$ebConfirm('确认参与应答吗?')
        .then(() => {
          this.isLoading = true;
          this.saveReplyService();
        })
        .catch(() => {});
    },
    async saveReplyService() {
      try {
        let { data } = await saveReply(this.project.projectId, this.user.userid, this.user.departId, 2);
        if (data.returnCode === '01') {
          this.$router.push('/projbid/reply/ruleedit/' + this.project.projectId + '/' + data.replyId);
        } else if (data['error'] && data['message']) {
          this.$message.error(data['message']);
        } else {
          this.$message.error('参与项目失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.isLoading = false;
    }
  }
};
</script>
<style scoped lang="less">
</style>
